/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateMealCategoryRequest } from '../models/create-meal-category-request';
import { GenericResponse } from '../models/generic-response';
import { GetMealCategoryResponse } from '../models/get-meal-category-response';
import { MealCategoryResponse } from '../models/meal-category-response';
import { UpdateMealCategoryRequest } from '../models/update-meal-category-request';

/**
 * Meal category master APIs
 */
@Injectable({ providedIn: 'root' })
export class MealCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllMealCategory()` */
  static readonly GetAllMealCategoryPath = '/api/v1/meal-categories';

  /**
   * Get list of meal categorys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMealCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMealCategory$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search meal category name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetMealCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MealCategoryService.GetAllMealCategoryPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetMealCategoryResponse>;
        })
      );
  }

  /**
   * Get list of meal categorys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMealCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMealCategory(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search meal category name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetMealCategoryResponse> {
    return this.getAllMealCategory$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetMealCategoryResponse>
        ): GetMealCategoryResponse => r.body
      )
    );
  }

  /** Path part for operation `createMealCategory()` */
  static readonly CreateMealCategoryPath = '/api/v1/meal-categories';

  /**
   * Create meal category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMealCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMealCategory$Response(
    params: {
      body: CreateMealCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<MealCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MealCategoryService.CreateMealCategoryPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<MealCategoryResponse>;
        })
      );
  }

  /**
   * Create meal category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMealCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMealCategory(
    params: {
      body: CreateMealCategoryRequest;
    },
    context?: HttpContext
  ): Observable<MealCategoryResponse> {
    return this.createMealCategory$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<MealCategoryResponse>): MealCategoryResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `getMealCategoryById()` */
  static readonly GetMealCategoryByIdPath = '/api/v1/meal-categories/{id}';

  /**
   * Get meal category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMealCategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMealCategoryById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<MealCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MealCategoryService.GetMealCategoryByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<MealCategoryResponse>;
        })
      );
  }

  /**
   * Get meal category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMealCategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMealCategoryById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<MealCategoryResponse> {
    return this.getMealCategoryById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<MealCategoryResponse>): MealCategoryResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `deleteMealCategory()` */
  static readonly DeleteMealCategoryPath = '/api/v1/meal-categories/{id}';

  /**
   * Delete meal category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMealCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMealCategory$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MealCategoryService.DeleteMealCategoryPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete meal category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMealCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteMealCategory(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteMealCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateMealCategory()` */
  static readonly UpdateMealCategoryPath = '/api/v1/meal-categories/{id}';

  /**
   * Update meal category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMealCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMealCategory$Response(
    params: {
      id: number;
      body: UpdateMealCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<MealCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      MealCategoryService.UpdateMealCategoryPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<MealCategoryResponse>;
        })
      );
  }

  /**
   * Update meal category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMealCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMealCategory(
    params: {
      id: number;
      body: UpdateMealCategoryRequest;
    },
    context?: HttpContext
  ): Observable<MealCategoryResponse> {
    return this.updateMealCategory$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<MealCategoryResponse>): MealCategoryResponse =>
          r.body
      )
    );
  }
}
